var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isLoading)?_c('gl-loading-icon',{attrs:{"size":"sm","label":_vm.__('Loading pipeline status')}}):(_vm.hasCiStatus)?_c('ci-icon',{attrs:{"status":_vm.ciStatus,"title":_vm.statusTitle,"aria-label":_vm.statusTitle}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }